const data = {
  'key1': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '150'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key2': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '150'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '除税系数(%)',
      'key': 'vatResFactor',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key3': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '150'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '含税市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '不含税市场价(元)',
      'key': 'marketPreTaxRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '调整系数(%)',
      'key': 'taxRatio',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key4': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '100'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '含税市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '不含税市场价(元)',
      'key': 'marketPreTaxRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '税率(%)',
      'key': 'taxRatio',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '采保费率(%)',
      'key': 'psCostRatio',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key5': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '100'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '含税市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '不含税市场价(元)',
      'key': 'marketPreTaxRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '进项税率(%)',
      'key': 'taxRatio',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key6': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '100'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '含税市场价(元)',
      'key': 'marketRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '不含税市场价(元)',
      'key': 'marketPreTaxRate',
      'className': 'font-right',
      'width': '100'
    },
    {
      'name': '税率/调整系数(%)',
      'key': 'taxRatio',
      'className': 'font-right',
      'width': '100'
    }
  ],
  'key7': [
    {
      'name': '编码',
      'key': 'code',
      'className': 'font-left',
      'width': '80'
    },
    {
      'name': '名称',
      'key': 'description',
      'className': 'font-left',
      'width': '150'
    },
    {
      'name': '规格型号',
      'key': 'spec',
      'className': 'font-center',
      'width': '100'
    },
    {
      'name': '单位',
      'key': 'unit',
      'className': 'font-center',
      'width': '40'
    },
    {
      'name': '实际含量',
      'key': 'usage',
      'className': 'font-right',
      'width': '50'
    },
    {
      'name': '不含税市场价(元)',
      'key': 'marketPreTaxRate',
      'or': 'marketRate',
      'className': 'font-right',
      'width': '100'
    }
  ]
}
const dataKey = {
  '安徽': 'key1',
  '重庆': 'key1',
  '贵州': 'key1',
  '河北': 'key2',
  '湖北': 'key3',
  '江苏': 'key4',
  '江西': 'key5',
  '吉林': 'key1',
  '陕西': 'key1',
  '山西': 'key1',
  '深圳': 'key1',
  '天津': 'key6',
  '云南': 'key7'
}

function getRegionKey (region){
  let key = dataKey[region]
  if (!key){
    return ''
  }
  return data[key]
}
export default getRegionKey
